import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import validate from "validate.js";
import { bindTasksToProgram } from "actions";
import { TimesheetTaskDropdown } from "CommonDropdowns";
import { isEmpty, filter } from "lodash";
import AccessRights from "utils/AccessRights";

const schema = {
  tasks: {
    presence: { allowEmpty: false, message: "^At least one task is required" },
  },
};

const AddTaskModal = ({ show, handleClose, programId, handleOpenNewTaskModal }) => {
  const dispatch = useDispatch();

  const session = useSelector((s) => s.session);
  
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  //finding task add module permission from user permissions
	const task_per = filter(session.user_permissions_raw, function(item){
		if(!isEmpty(item)){
		  return item.object_code === 'task';
		}
	});

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      tasks: [],
      repAccess: "0",
    },
    touched: {},
    errors: {},
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  const handleTaskChange = (selected) => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        tasks: selected,
      },
      touched: {
        ...formState.touched,
        tasks: true,
      },
    }));
  };

  const handleChange = (event) => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }));
  };

  const handleBindTasks = (event) => {
    event.preventDefault();
    const taskIds = formState.values.tasks.map((item) => item.value);
    let data = {
      task_ids: taskIds,
      repAccess: formState.values.repAccess,
      object_viewed_id: object_viewed_id,
    }

    if (formState.isValid) {
      dispatch(bindTasksToProgram(programId, data, onModelClose));
      
    }
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const onModelClose = () => {
    handleClose();
    setFormState({
      isValid: false,
      values: { tasks: [], repAccess: "0" },
      touched: {},
      errors: {},
    });
  };

  return (
    <Modal show={show} onHide={onModelClose} centered className="add-new-program">
      <div className="p-2">
        <Modal.Header  className="p-2" closeButton>
          <Modal.Title>Bind Tasks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleBindTasks}>
            
            <TimesheetTaskDropdown
              isMulti
              taskValue={formState.values.tasks}
              taskOnChange={handleTaskChange}
              showSelectAllOption={false}
              programId={programId}
              loadUnbinded={true}
            />
            {hasError("tasks") && (
              <div className="invalid-feedback d-block">
                {formState.errors.tasks[0]}
              </div>
            )}

            <Form.Group>
              <Form.Label className="label-input">Rep Access</Form.Label>
              <Form.Select
                className="input-field"
                name="repAccess"
                onChange={handleChange}
                value={formState.values.repAccess}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Select>

              {hasError("repAccess") && ( 
                <div className="invalid-feedback d-block">
                  {formState.errors.repAccess[0]}
                </div>
              )}
            </Form.Group>
            

            <Row className="mt-3">
              <Col lg={6}>
                <button className="c-b-btn w-100" onClick={onModelClose}>
                  Cancel
                </button>
              </Col>
              <Col lg={6}>
                <button className="n-u-btn w-100" onClick={handleBindTasks} disabled={!formState.isValid}>
                  Update
                </button>
              </Col>
            </Row>

          </Form>
        </Modal.Body>

        {!isEmpty(task_per) && AccessRights(task_per[0], 'add') ?
          <Modal.Footer className="justify-content-center">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleClose(); // 👈 Close the first modal
                //handleOpenCreate(); // 👈 Then open the second modal
                handleOpenNewTaskModal();
              }}
              className="font-12 font-weight-s-bold heading-color"
            >
              Can’t find a Task? Add a new one here.
            </a>
          </Modal.Footer>
        :""}
      </div>
    </Modal>
  );
};

export default AddTaskModal;
